import { usePage } from "@inertiajs/react";
import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputAdornment,
} from "@mui/material";
import Input from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";

const PRICE_FACTOR = 0.02;

const formatCost = (trainCost: number) => {
  if (trainCost === -1) {
    return "Er ging iets mis";
  }

  if (!trainCost) {
    return "";
  }

  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
  }).format(trainCost);
};

const JourneyCost = ({
  discount,
  from,
  name,
  onChange,
  to,
}: {
  from?: string;
  discount?: string;
  name: string;
  onChange: (e: { target: { name: string; value: number | string } }) => void;
  to?: string;
}) => {
  const { baseUrl } = usePage().props;
  const [rawTrainCost, setRawTrainCost] = useState(0);
  const [otherCost, setOtherCost] = useState<number | null>(0);
  const trainCost =
    rawTrainCost > 0 ? rawTrainCost * Number(discount) : rawTrainCost;

  useEffect(() => {
    if (from && to) {
      setRawTrainCost(0);

      if (from !== to) {
        fetch(`${baseUrl}/trains/cost?from=${from}&to=${to}`, {
          method: "GET",
        })
          .then((response) =>
            response.json().then((json) => {
              const price = json?.[0]?.productFare?.priceInCents;
              setRawTrainCost(price ? price * PRICE_FACTOR : -1);
            }),
          )
          .catch(console.error);
      }
    }
  }, [from, to]);

  useEffect(() => {
    onChange({
      target: {
        name,
        value: trainCost * 100 + (otherCost ?? 0) * 100,
      },
    });
  }, [rawTrainCost, discount, otherCost]);

  return (
    <>
      <FormControl>
        <FormLabel>Verwachte treinkosten</FormLabel>
        <TextField
          disabled
          name={name}
          placeholder="Wordt automatisch berekend"
          value={formatCost(trainCost)}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Verwachte overige reiskosten</FormLabel>
        <Input
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          type="number"
          value={otherCost ?? ""}
          onChange={(e) =>
            setOtherCost(e.target.value ? Number(e.target.value) : null)
          }
        />
        <FormHelperText>Bv bus of tram</FormHelperText>
      </FormControl>
    </>
  );
};

export default JourneyCost;
